import React from 'react';
import classnames from 'classnames';

import Option from 'components/atoms/Option';

import styles from './index.css';

const Options = ({
	selected,
	options,
	reverse,
	border,
	select,
	optionClass,
	moreWeight,
}) => (
	<div className={styles.options}>
		{options.map(option => (
			<Option
				key={option.id}
				className={classnames(styles.option, optionClass)}
				border={border}
				reverse={reverse}
				active={option.id === selected.id}
				onSelect={() => { select(option); }}
				moreWeight={moreWeight}
			>
				{option.label}
			</Option>
		))}
	</div>
);

export default Options;



// WEBPACK FOOTER //
// ./src/components/atoms/Options/component.js